// Phase 6 — Track D T-D5. DateRow.

import type { DateEvent } from '@dailydeck/shared/types';
import { copy } from '@dailydeck/shared/copy';
import { ListRow } from '../../components/ui/ListRow.js';
import { Badge } from '../../components/ui/Badge.js';
import { formatDate } from '../../lib/dateFormat.js';

export interface DateRowProps {
  event: DateEvent;
  today: Date;
}

export function DateRow({ event, today }: DateRowProps): JSX.Element {
  const next = event.next_occurrence_on ?? event.occurs_on;
  const recurrenceLabel = copy.dates.recurrenceLabels[event.recurrence];
  return (
    <ListRow data-event-id={event.id} data-testid="date-row" className="items-center gap-3">
      <div className="flex-1 min-w-0">
        <p className="text-body-strong truncate">{event.label}</p>
        {event.notes !== null && event.notes !== '' && (
          <p className="text-caption text-text-secondary truncate">{event.notes}</p>
        )}
      </div>
      <Badge variant="neutral" data-testid="date-recurrence">{recurrenceLabel}</Badge>
      <span className="text-caption text-text-muted tabular w-32 text-right">
        {formatDate(next, today)}
      </span>
    </ListRow>
  );
}
